<div class="__left-group">
  <awair-dashboard-logo class="__logo"
                        [color]="'#ACB4BB'">
  </awair-dashboard-logo>
  <div class="__divider"></div>
  <span class="__name">Floor Plan Editor</span>
</div>

<div class="__right-group">
  <awair-cross-icon class="__close-btn"
                    [strokeWidth]="0.1"
                    (click)="onClose(isFloorPlanEdited, hasSelectedFloor)">
  </awair-cross-icon>
</div>
